import React from "react";
import "../../buttonComponentStyle.css";

const ButtonComponent = ({
  label,
  onClick,
  type = "primary",
  size = "medium",
  disabled = false,
  isLoading = false,
  icon
}) => {
  return (
    <button
      className={`btn ${type} ${size} ${isLoading ? 'loading' : ''}`} // Add 'loading' class when isLoading
      onClick={onClick}
      disabled={disabled || isLoading}
    >
      <span className="btn-content-wrapper">
        {isLoading ? (
          // Display "Loading..." with dots animation when isLoading
          <span className="loading-text">Loading<span className="dot-animation">.</span><span className="dot-animation delay-1">.</span><span className="dot-animation delay-2">.</span></span>
        ) : (
          // Display original icon and label when not loading
          <>
            {icon && <span className="btn-icon">{icon}</span>}
            <span>{label}</span>
          </>
        )}
      </span>
    </button>
  );
};
export default ButtonComponent;